import { createContext } from 'react';
import { DetailsObjectType } from 'store/pages/loaders/loader-types';

export const DetailsContext = createContext<DetailsObjectType | null>(null);

DetailsContext.displayName = 'DetailsContext';
